<template>
  <div class="container">
    <tab-contents-on-site />
  </div>
</template>

<script>
import TabContentsOnSite from "../components/tab/TabContentsOnSite.vue";

export default {
  components: {
    TabContentsOnSite,
  },
};
</script>

<style lang="scss" scoped>
.container {
  // padding-top: 6px;
  display: flex;
  flex-direction: column;
}
</style>
